export default __webpack_public_path__ + "static/socialCard-f62e8c92ca6e5e9557e92789f6971e34.jpg";